<template>
  <div :class="errMessage.length?'errItem':''">
    <b-row :class="itemStyle">
      <b-col sm="3" :class="labelClass + ' labelWrap'">
        <div class="badgeWrap">
          <div v-if="isRequired" class="mr-2 badge badge-required">必須</div>
        </div>
        <div class="label"><label>{{ label }}</label></div>
      </b-col>
      <calendar
        :name="name"
        :value="value"
        :format="DatePickerFormat"
        :language="ja"
        :typeable="true"
        :input-class=" 'calendar ' + inputClass"
        ref="picker"
        :calendar-button="true"
        calendar-button-icon="event"
        :disabled="disabled"
        :disabledDates="disabledDates"
        @selected="dateSelected"
      >
      </calendar>
      <unicon name="calendar-alt"
        fill="#495057"
        class="calendar-icon"
        ></unicon>
    </b-row>
    <span class="error" v-if="errMessage.length">
      {{ errMessage[0] }}
    </span>
  </div>
</template>
<script>
import moment from 'moment';
import datepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'CalendarBox',
  data() {
    return {
      DatePickerFormat: 'yyyy/MM/dd',
      ja,
      gender: '',
    };
  },
  components: {
    calendar: datepicker,
  },
  props: {
    label: {},
    itemStyle: {},
    value: {},
    inputClass: {},
    disabled: { type: Boolean, default: false },
    disabledDates: {},
    errMessage: {},
    name: { type: String, require: true },
    labelClass: { type: String, default: 'right' },
    isRequired: { type: Boolean, default: false },
  },
  methods: {
    // 日付が消された／パースできない場合、moment は "Invalid date" という文字列を返す。
    // これをそのまま emit すると「空に見えるのに真値」となり、画面・サーバ双方の
    // 未入力チェックをすり抜けて new Carbon() で例外になる（zz05）。
    // 無効なときは空文字を返し、利用側の falsy 判定に素直に乗せる。
    dateSelected(event) {
      const d = moment(event);
      this.$emit('input', d.isValid() ? d.format('YYYY/MM/DD') : '');
    },
  },
};
</script>
<!-- カレンダーはscopedのcssが当たらないもよう -->
<style>
.line input.calendar{
  height: 50px;
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
input.w-small{
  width:175px;
}
.calendar-icon{
  position: relative;
  left: -32px;
}
.errItem input.calendar{
  border:solid 1px #dc3545 !important;
}
.pickerDateForm::-ms-clear {
    visibility:hidden !important;
}
.event {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  right: 1px;
  z-index: 1;
}
</style>
<style scoped>
.line .labelWrap,
.line .labelWrap label{
  width: 180px;
  max-width: 237px;
}
.line .labelWrap{
  width: 237px;
  min-width: 237px;
}
.line{
  align-items: center;
  margin:10px 0 !important;
}
.line label{
  align-items:center;
  margin:0;
}
.line .right{
  text-align: right;
}
.line .labelWrap {
  margin-right: 0;
  padding-right: 0;
  text-align: left;
}
.line .labelWrap .badgeWrap,
.line .labelWrap .label{
  display: inline-block;
}
.line .labelWrap .badgeWrap div{
  vertical-align: middle;
}
.error{
  display:block;
  text-align: left;
  padding-left: 25%;
  margin-top: -6px;
  font-size: 80%;
  color: #dc3545;
}
</style>
